<form [formGroup]="formCadastrar" (submit)="OnPesquisar()">
  <breadcrumb
    [paginas]="[
      { route: '/home', name: 'Home' },
      { route: '/chamados-unificado-list', name: 'Consultar Chamados' },
    ]"
  />

  <!-- SAUDACAO USUARIO -->
  <section class="section-saudacao">
    <div class="container">
      <p>
        <b>Olá,</b>
        {{
          this.userLogado?.flPsicologo
            ? "Psicólogo(a)"
            : this.atribuicoesLogin.NomePerfil
        }}<br />
        <b>{{
          this.userLogado?.flPsicologo
            ? this.userLogado?.nome
            : this.atribuicoesLogin.Nome
        }}</b>
      </p>
    </div>
  </section>

  <!-- FILTRO ESCOLA -->
  <app-filtro-padrao
    [escolaObrigatoria]="false"
    [anoObrigatorio]="false"
    (filtroEmitter)="listeningFiltroEmitter($event)"
  ></app-filtro-padrao>

  <!-- RESULTADOS -->
  <section class="conteudo-principal">
    <!-- TITULO -->
    <div class="container conteudo-principal-filtro">
      <section class="section-saudacao header-page-voltar">
        <div class="container">
          <h2 class="titulo-page" #target>Consultar Chamados</h2>
        </div>
      </section>
      <div>
        <br />
        <span class="filtro-titulo">Filtrar chamados</span>
        <!-- LISTAGEM CHAMADOS -->
        <div class="time-line mx-w-900">
          <div class="section-filtro filtro-gravidade-status">
            <div class="container">
              <div class="grupo-filter-full">
                <label for="nomeAluno">Nome</label>
                <input
                  type="text"
                  formControlName="nomeAluno"
                  id="nomeAluno"
                  placeholder="Digite o nome do aluno."
                  name="nomeAluno"
                  (blur)="FiltraChamadosAtuais()"
                  class="form-control"
                />
              </div>
              <div class="grupo-filter-full">
                <label for="raAluno">RA</label>
                <input
                  type="number"
                  formControlName="raAluno"
                  id="raAluno"
                  onlyNumber
                  placeholder="Digite o RA do aluno."
                  name="raAluno"
                  (blur)="FiltraChamadosAtuais()"
                  class="form-control input"
                />
              </div>
              <div class="grupo-filter-full">
                <label for="codigoChamado">Nº Chamado</label>
                <input
                  type="number"
                  onlyNumber
                  placeholder="Digite o Id de um chamado."
                  formControlName="codigoChamado"
                  id="codigoChamado"
                  name="codigoChamado"
                  (blur)="FiltraChamadosAtuais()"
                  class="form-control input-cd"
                />
              </div>
              <div class="grupo-filter-full">
                <label for="cpfEquipeEscolar">CPF(Equipe escolar)</label>
                <input
                  type="text"
                  placeholder="Digite o CPF"
                  id="cpfEquipeEscolar"
                  formControlName="cpfEquipeEscolar"
                  name="cpfEquipeEscolar"
                  mask="000.000.000-00"
                  [validation]="true"
                />
              </div>
              <div class="col-md-3">
                <label for="codigoStatus" class="form-label">Status</label>
                <ng-select
                  [items]="filtro.status"
                  bindLabel="name"
                  bindValue="id"
                  placeholder="Selecione um status"
                  formControlName="codigoStatus"
                  [clearable]="true"
                  id="codigoStatus"
                >
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.name }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <div>
                      <strong>{{ item.name }}</strong>
                      <div class="text-muted small">
                        <div *ngFor="let variant of item.variants">
                          • {{ variant }}
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <div class="grupo-filter-full">
                <label for="codigoGravidade">Gravidade</label>
                <ng-select
                  [items]="this.filtro.gravidades"
                  bindLabel="name"
                  bindValue="id"
                  placeholder="Selecione uma Gravidade"
                  id="codigoGravidade"
                  class="codigoGravidade"
                  formControlName="codigoGravidade"
                  name="codigoGravidade"
                  (change)="FiltraChamadosAtuais()"
                >
                </ng-select>
              </div>
            </div>
          </div>
          <br />
          <div class="container">
            @if (this.listarChamados && this.listarChamados.length > 0) {
              @for (
                chamado of this.listarChamados
                  | slice: (page - 1) * 4 : page * 4;
                track chamado.codigoChamado
              ) {
                <div class="card-chamado">
                  <div class="card-chamado-avatar">
                    <div class="card-chamado-foto">
                      {{
                        chamado.tipoPessoa == 1 && chamado.aluno?.nomeAluno
                          ? chamado.aluno?.nomeAluno
                              ?.substring(0, 2)
                              ?.toUpperCase()
                          : chamado.tipoPessoa == 2 &&
                              chamado.equipeEscolar?.nome
                            ? chamado.equipeEscolar?.nome
                                ?.substring(0, 2)
                                ?.toUpperCase()
                            : chamado.descricaoOutros
                              ? chamado.descricaoOutros
                                  .substring(0, 2)
                                  .toUpperCase()
                              : "NC"
                      }}
                    </div>
                  </div>

                <div class="card-chamado-conteudo">
                  <div class="card-chamado-header">
                    <a
                      [routerLink]="['/detalhe', chamado.codigoChamado]"
                      class="card-chamado-link"
                    >
                      Chamado {{ chamado.codigoChamado }}
                    </a>
                    <span
                      class="card-chamado-badge"
                      [ngClass]="{
                        amarelo: chamado.nomeGravidade === 'Amarelo',
                        vermelho: chamado.nomeGravidade === 'Vermelho',
                        verde: chamado.nomeGravidade === 'Verde',
                        laranja: chamado.nomeGravidade === 'Laranja',
                      }"
                    >
                      {{ chamado.nomeGravidade }}
                    </span>
                  </div>

                    <div class="card-chamado-nome">
                      {{
                        chamado.tipoPessoa == 1
                          ? chamado.aluno?.ra
                            ? chamado.aluno?.ra +
                              " - " +
                              (chamado.aluno?.nomeAluno || "")
                            : "Não Identificado"
                          : chamado.tipoPessoa == 2
                            ? chamado.aluno?.cpf
                              ? chamado.aluno?.cpf +
                                " - " +
                                (chamado.aluno?.nomeAluno || "")
                              : "Não Identificado"
                            : chamado.aluno?.nomeAluno || "Não Identificado"
                      }}
                    </div>

                    <div
                      class="card-chamado-info"
                      *ngIf="chamado.aluno?.descricaoTurma"
                    >
                      {{ chamado.aluno?.descricaoTurma }}
                    </div>

                    <div class="card-chamado-info">
                      {{ chamado.dsPessoa }} - {{ chamado.dsEnvolvido }} -
                      {{ chamado.nomeSubCategoria }}
                    </div>

                    <div class="card-chamado-detalhes">
                      <div class="card-chamado-detalhe-item">
                        <small>Em aberto</small>
                        <strong>{{ chamado.horasAtras }}</strong>
                      </div>
                      <div class="card-chamado-detalhe-item">
                        <small>Abertura em</small>
                        <strong>{{
                          chamado.dataInclusao | date: "dd/MM/yyyy HH:mm"
                        }}</strong>
                      </div>
                      <div class="card-chamado-detalhe-item">
                        <small>Aconteceu em</small>
                        <strong>{{
                          chamado.dataChamado | date: "dd/MM/yyyy HH:mm"
                        }}</strong>
                      </div>
                      <div class="card-chamado-detalhe-item">
                        <small>Status</small>
                        <span
                          class="card-chamado-status"
                          [ngClass]="getCorStatus(chamado.status)"
                        >
                          {{
                            chamado.aluno?.dsStatusEnvolvido ||
                              chamado.status ||
                              "Status"
                          }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="card-chamado-acao">
                    <button
                      class="card-chamado-btn"
                      (click)="visualizarChamado(chamado.codigoChamado)"
                    >
                      Visualizar chamado
                    </button>
                  </div>
                </div>
              }

              <ngb-pagination
                [(page)]="page"
                [pageSize]="4"
                [maxSize]="4"
                [collectionSize]="this.listarChamados.length"
                class="d-flex justify-content-center"
                size="lg"
              />
            } @else {
              <div class="listagem-card-chamado">
                <p class="sem-resultados">
                  @if (temFiltrosAtivos()) {
                    Nenhum chamado encontrado com os filtros aplicados.
                  }
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </section>
</form>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>
